module.exports = "/assets/data/1fbefc5bee627e35649ce9abac7c17e9-BN16.data.json";